<div class="@container">
  <div class="grid grid-cols-1 gap-x-[3rem] gap-y-2.5 mt-1.5 sm:mt-2.5 @[49rem]:grid-cols-2 @[74rem]:grid-cols-3">
    @for(event of events(); track event.uniqueId; let index = $index) {
      @switch (index) {
        @case(0) {
          <app-event-card [event]="event" [canOverrideEventLink]="canOverrideEventLink()"></app-event-card>
        }
        @case(1) {
          <app-event-card class="hidden @[49rem]:block" [event]="event" [canOverrideEventLink]="canOverrideEventLink()"></app-event-card>
          <app-small-event-card class="@[49rem]:hidden" [event]="event" [canOverrideEventLink]="canOverrideEventLink()"></app-small-event-card>
        }
        @case(2) {
          <app-event-card class="hidden @[74rem]:block" [event]="event" [canOverrideEventLink]="canOverrideEventLink()"></app-event-card>
          <app-small-event-card class="@[74rem]:hidden" [event]="event" [canOverrideEventLink]="canOverrideEventLink()"></app-small-event-card>
        }
        @default {
          <app-small-event-card [event]="event" [canOverrideEventLink]="canOverrideEventLink()"></app-small-event-card>
        }
      }
    }
  </div>
</div>
